import { bindDataAndCallFunctions } from "./bindDataAndCallFunctions.js";
import { drawLabel } from "./drawLabel.js";

const drawRect = (container, data, onDrag) => {
  bindDataAndCallFunctions(
    container.selectAll("rect"),
    [data],
    (enter) =>
      enter
        .append("rect")
        .attr("width", (d) => d.size.width)
        .attr("height", (d) => d.size.height),
    (update) => update,
    (exit) => exit.remove()
  );
  drawLabel(container, data, onDrag);
};

export { drawRect };
